import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "13px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          cursor: "pointer",
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const AddHealthScoreFactor = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("factor", editData?.factor);
      formik.setFieldValue("weight", editData?.weight);
      formik.setFieldValue("good_signal", editData?.good_signal);
      formik.setFieldValue("bad_signal", editData?.bad_signal);
      formik.setFieldValue("max_points", editData?.max_points);
    }
  }, [editData]);

  const validationSchema = yup.object({
    factor: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    weight: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    good_signal: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    bad_signal: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    max_points: yup
      .number("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      factor: "",
      weight: "",
      good_signal: "",
      bad_signal: "",
      max_points: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        factor: values.factor,
        weight: values.weight,
        good_signal: values.good_signal,
        bad_signal: values.bad_signal,
        max_points: values.max_points,
      };

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `health-score-factors/update-factor/${editData?.id}`
            : `health-score-factors/add-factor`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>
            {editData?.id
              ? "Edit Health Score Factor"
              : "Add Health Score Factor"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* factor */}
                  <FeildWraper width="100%">
                    <FormLabel required>Factor</FormLabel>
                    <input
                      type="text"
                      name="factor"
                      value={formik.values.factor}
                      onChange={formik.handleChange}
                      placeholder="Factor"
                    />
                    {formik.touched.factor && formik.errors.factor && (
                      <FeildError>{formik.errors.factor}</FeildError>
                    )}
                  </FeildWraper>

                  {/* weight */}
                  <FeildWraper>
                    <FormLabel required>Weight</FormLabel>
                    <input
                      type="number"
                      name="weight"
                      min="0"
                      value={formik.values.weight}
                      onChange={formik.handleChange}
                      placeholder="Weight"
                    />
                    {formik.touched.weight && formik.errors.weight && (
                      <FeildError>{formik.errors.weight}</FeildError>
                    )}
                  </FeildWraper>
                  {/* Max Points */}
                  <FeildWraper>
                    <FormLabel required>Max Points</FormLabel>
                    <input
                      type="number"
                      name="max_points"
                      min="0"
                      value={formik.values.max_points}
                      onChange={formik.handleChange}
                      placeholder="Max Points"
                    />
                    {formik.touched.max_points && formik.errors.max_points && (
                      <FeildError>{formik.errors.max_points}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Good Signal */}

                  <FeildWraper>
                    <FormLabel required>Good Signal</FormLabel>
                    <input
                      type="text"
                      name="good_signal"
                      value={formik.values.good_signal}
                      onChange={formik.handleChange}
                      placeholder="Good Signal"
                    />
                    {formik.touched.good_signal &&
                      formik.errors.good_signal && (
                        <FeildError>{formik.errors.good_signal}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Bad Signal */}

                  <FeildWraper>
                    <FormLabel required>Bad Signal</FormLabel>
                    <input
                      type="text"
                      name="bad_signal"
                      value={formik.values.bad_signal}
                      onChange={formik.handleChange}
                      placeholder="Bad Signal"
                    />
                    {formik.touched.bad_signal && formik.errors.bad_signal && (
                      <FeildError>{formik.errors.bad_signal}</FeildError>
                    )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddHealthScoreFactor;
